import { Activity, IOTransitionType, Point, Position, Set, Transition, Workflow } from "../workflowModel";
import { Action, CallMethod, CallScript, IncrementDateTime, IncrementNumber, OpenForm, SendMail, SendMessageRecipientType, SendSMS, SendSmsRecipientType, SendWFMessage, SetAttribute, SetAttributeValueType, SetObjectAttribute, SetValue } from "../workflowModel/Actions";
import { DefinitionParticipant, Owner, Participant, Role, System, User } from "../workflowModel/Participants";
import { AttributeDataChange, Menu, NewObject, Trigger, WfMessage } from "../workflowModel/Triggers";
import { CONST_ACTION_COMMENT_AT, CONST_ACTION_CONDITION_AT, CONST_ACTIONS_EL, CONST_ACTIVITY_CONDITION_AT, CONST_ACTIVITY_DESCRIPTION_AT, CONST_ACTIVITY_EL, CONST_ACTIVITY_ID_AT, CONST_ACTIVITY_INHERIT_PARTICIPANTS_AT, CONST_ACTIVITY_INPUT_TRANS_TYPE_AT, CONST_ACTIVITY_KILL_CHILDREN_AT, CONST_ACTIVITY_NAME_AT, CONST_ACTIVITY_ORDER_AT, CONST_ACTIVITY_RUN_CONDITION_AT, CONST_ACTIVITY_SHOW_IN_WF_HISTORY_AT, CONST_ACTIVITY_TYPE_AT, CONST_ATTRIBUTE_DATA_CHANGE_ATTR_NAME_AT, CONST_ATTRIBUTE_DATA_CHANGE_CONDITION_AT, CONST_ATTRIBUTE_DATA_CHANGE_EL, CONST_CALL_METHOD_DEFAULT_PARAM_VALUE_AT, CONST_CALL_METHOD_EL, CONST_CALL_METHOD_INSERT_ACTUAL_OBJECT_AT, CONST_CALL_METHOD_INSERT_PARAM_FORM_OBJECT_AT, CONST_CALL_METHOD_METHOD_NAME_AT, CONST_CALL_METHOD_STATIC_AT, CONST_CALL_SCRIPT_EL, CONST_DEFINITION_PARTICIPANT_CONDITION_AT, CONST_DEFINITION_PARTICIPANT_EL, CONST_DEFINITION_PARTICIPANT_NAME_AT, CONST_DEFINITION_PARTICIPANT_ROLE_NAME_AT, CONST_DEFINITION_PARTICIPANTS_EL, CONST_DRAW_EL, CONST_DRAW_SET_AT, CONST_INCREMENT_DATE_TIME_ATTR_NAME_AT, CONST_INCREMENT_DATE_TIME_EL, CONST_INCREMENT_DATE_TIME_PRECISION_AT, CONST_INCREMENT_DATE_TIME_VALUE_AT, CONST_INCREMENT_NUMBER_ATTR_NAME_AT, CONST_INCREMENT_NUMBER_EL, CONST_INCREMENT_NUMBER_VALUE_AT, CONST_MENU_CAPTIONS_EL, CONST_MENU_CHOOSE_FROM_USERS_DEFAULT, CONST_MENU_CODE_NAME, CONST_MENU_CONFIRM_MESSAGES_EL, CONST_MENU_EL, CONST_MENU_ICON_NAME, CONST_MENU_IDENTIFIER_AT, CONST_MENU_LANG_AT, CONST_MENU_LINK_ATTR_FOR_SEL_OBJ_AT, CONST_MENU_MASTER_NODE_AT, CONST_MENU_MULTI_ACTION_ENABLE_AT, CONST_MENU_PARAM_FORM_NAME_AT, CONST_MENU_PARTICIPANTS_SELECTING_AT, CONST_MENU_SET_VALUES_AT, CONST_MENU_TEXT_AT, CONST_MENU_TEXT_EL, CONST_MENU_VALIDATE_POST_REQ_AT, CONST_MENU_VALIDATE_RECOMMENDED_AT, CONST_NEW_OBJECT_EL, CONST_OWNER_EL, CONST_PARTICIPANTS_EL, CONST_POINT_EL, CONST_POINT_X_AT, CONST_POINT_Y_AT, CONST_POSITION_EL, CONST_POSITION_HEIGHT_AT, CONST_POSITION_SET_AT, CONST_POSITION_WIDTH_AT, CONST_POSITION_X_AT, CONST_POSITION_Y_AT, CONST_ROLE_DB_ID_AT, CONST_ROLE_EL, CONST_ROLE_NAME_AT, CONST_SEND_MAIL_DOCUMENT_ATTRIBUTE_AT, CONST_SEND_MAIL_DOCUMENT_CLASS_NAME_AT, CONST_SEND_MAIL_DOCUMENT_CONDITION_AT, CONST_SEND_MAIL_DOCUMENT_CONDITION_PARAMS_AT, CONST_SEND_MAIL_EL, CONST_SEND_MAIL_FORMAT_AT, CONST_SEND_MAIL_RECIPIENT_AT, CONST_SEND_MAIL_RECIPIENT_TYPE_AT, CONST_SEND_MAIL_REPORT_TEMPLATE_AT, CONST_SEND_MAIL_SEND_POSTPONE_AT, CONST_SEND_MAIL_SUBJECT_AT, CONST_SEND_MAIL_SUMMARY_MAIL_AT, CONST_SEND_MAIL_TEXT_AT, CONST_SEND_SMS_EL, CONST_SEND_SMS_RECIPIENT_AT, CONST_SEND_SMS_RECIPIENT_TYPE_AT, CONST_SEND_SMS_TEXT_AT, CONST_SEND_WF_MESSAGE_AFTER_SAVE_AT, CONST_SEND_WF_MESSAGE_EL, CONST_SEND_WF_MESSAGE_MESSAGE_NAME_AT, CONST_SEND_WF_MESSAGE_OBJECTS_CONDITION_AT, CONST_SEND_WF_MESSAGE_OBJECTS_CONDITION_PARAMS_AT, CONST_SEND_WF_MESSAGE_TARGET_OBJECT_NAME_AT, CONST_SET_ATTRIBUTE_ATTR_NAME_AT, CONST_SET_ATTRIBUTE_EL, CONST_SET_ATTRIBUTE_VALUE_EL, CONST_SET_ATTRIBUTE_VALUE_TYPE, CONST_SET_DEFINITIONS_EL, CONST_SET_DESCRIPTION_AT, CONST_SET_EL, CONST_SET_NAME_AT, CONST_SET_OBJECT_ATTRIBUTE_ATTR_NAME_AT, CONST_SET_OBJECT_ATTRIBUTE_EL, CONST_SET_OBJECT_ATTRIBUTE_MASTER_ATTR_NAME_AT, CONST_SET_OBJECT_ATTRIBUTE_MASTER_CLASS_NAME_AT, CONST_SET_OBJECT_ATTRIBUTE_VALUE_EL, CONST_SET_VALUE_EL, CONST_SET_VALUE_NAME_AT, CONST_SET_VALUE_VALUE_EL, CONST_SYSTEM_EL, CONST_TRANSITION_CONDITION_AT, CONST_TRANSITION_EL, CONST_TRANSITION_ID_AT, CONST_TRANSITION_NAME_AT, CONST_TRANSITION_TO_AT, CONST_TRANSITIONS_EL, CONST_TRIGGERS_EL, CONST_USER_DB_ID_AT, CONST_USER_EL, CONST_USER_NAME_AT, CONST_WFMESSAGE_DEACTIVATING_AT, CONST_WFMESSAGE_EL, CONST_WFMESSAGE_MESSAGE_NAME_AT, CONST_WORKFLOW_CLASS_NAME_AT, CONST_WORKFLOW_DEFINITION_VERSION_AT, CONST_WORKFLOW_EL, CONST_WORKFLOW_IDENTIFIER_AT, CONST_WORKFLOW_VERSION_AT } from "./constants";
import { manageOpenFormAction } from "./oldSilverlightFunctions";
import { escapeXmlString, getCsharpTypeFromString } from "./utils";

const WORKFLOW_XML_NAMESPACE = "http://schemas.tescosw.cz/core/workflow";

/**
 * Funkce přijímá parametr @param workflow a převádí jej do XML podoby.
 * @param workflow Workflow objekt, ze kterého se má vytvořit xml.
 */
export const workflowToXml = async (workflow: Workflow) => {
    const xmlDoc = document.implementation.createDocument(WORKFLOW_XML_NAMESPACE, CONST_WORKFLOW_EL);
    const wfElement = xmlDoc.documentElement;

    wfElement.setAttribute("xmlns:xsd", "http://www.w3.org/2001/XMLSchema");
    wfElement.setAttribute("xmlns:xsi", "http://www.w3.org/2001/XMLSchema-instance");
    wfElement.setAttribute(CONST_WORKFLOW_DEFINITION_VERSION_AT, workflow.definitionVersion);
    workflow.version && wfElement.setAttribute(CONST_WORKFLOW_VERSION_AT, workflow.version);
    wfElement.setAttribute(CONST_WORKFLOW_IDENTIFIER_AT, workflow.identifier);
    wfElement.setAttribute(CONST_WORKFLOW_CLASS_NAME_AT, workflow.className);

    // Přidání Aktivit
    for (let i = 0; i < workflow.activities.length; i++) {
        await addActivityElement(xmlDoc, wfElement, workflow.activities[i], workflow.sets);
    }

    // Přidání SetDefinitions
    const setDefinitionsEl = xmlDoc.createElementNS(WORKFLOW_XML_NAMESPACE, CONST_SET_DEFINITIONS_EL);
    for (let i = 0; i < workflow.sets.length; i++) {
        addSetElement(xmlDoc, setDefinitionsEl, workflow.sets[i]);
    }

    // Přidání DefinitionParticipants
    const definitionParticiapntsEl = xmlDoc.createElementNS(WORKFLOW_XML_NAMESPACE, CONST_DEFINITION_PARTICIPANTS_EL);
    for (let i = 0; i < workflow.definitionParticipants.length; i++) {
        addDefinitionParticipantElement(xmlDoc, definitionParticiapntsEl, workflow.definitionParticipants[i]);
    }

    wfElement.appendChild(setDefinitionsEl);
    wfElement.appendChild(definitionParticiapntsEl);

    return xmlDoc.documentElement.outerHTML;
};

const addActivityElement = async (xmlDoc: Document, wfElement: Element, activity: Activity, sets: Set[]) => {
    const activityEl = xmlDoc.createElementNS(WORKFLOW_XML_NAMESPACE, CONST_ACTIVITY_EL);

    activity.condition !== "" && activityEl.setAttribute(CONST_ACTIVITY_CONDITION_AT, activity.condition!);
    activity.runCondition !== "" && activityEl.setAttribute(CONST_ACTIVITY_RUN_CONDITION_AT, activity.runCondition!);
    activityEl.setAttribute(CONST_ACTIVITY_ID_AT, activity.id);
    activityEl.setAttribute(CONST_ACTIVITY_TYPE_AT, activity.type);
    activityEl.setAttribute(CONST_ACTIVITY_ORDER_AT, activity.order.toString());
    activity.killChildren && activityEl.setAttribute(CONST_ACTIVITY_KILL_CHILDREN_AT, "true");
    !activity.showInWfHistory && activityEl.setAttribute(CONST_ACTIVITY_SHOW_IN_WF_HISTORY_AT, "false");
    activity.inheritParticipants && activityEl.setAttribute(CONST_ACTIVITY_INHERIT_PARTICIPANTS_AT, "true");
    activity.inputTransType === IOTransitionType.and && activityEl.setAttribute(CONST_ACTIVITY_INPUT_TRANS_TYPE_AT, IOTransitionType.and);
    activityEl.setAttribute(CONST_ACTIVITY_DESCRIPTION_AT, activity.description);
    activityEl.setAttribute(CONST_ACTIVITY_NAME_AT, activity.name);

    // Přidání Actions
    const actionsEl = xmlDoc.createElementNS(WORKFLOW_XML_NAMESPACE, CONST_ACTIONS_EL);
    for (const action of activity.actions) {
        await action.validate();
        addActionElement(xmlDoc, actionsEl, action);
    }
    manageOpenFormAction(WORKFLOW_XML_NAMESPACE, xmlDoc, actionsEl, activity.actions); // Stará se o zpracování akcí OpenForm, snad se brzo refaktoruje, ať to odtud zmizí :(

    // Přidání Transitions
    const transitionsEl = xmlDoc.createElementNS(WORKFLOW_XML_NAMESPACE, CONST_TRANSITIONS_EL);
    activity.transitions.forEach(transition => {
        addTransitionElement(xmlDoc, transitionsEl, transition, sets);
    });

    // Přidání Participants
    const participantsEl = xmlDoc.createElementNS(WORKFLOW_XML_NAMESPACE, CONST_PARTICIPANTS_EL);
    activity.participants.forEach(participant => {
        addParticipantElement(xmlDoc, participantsEl, participant);
    });

    // Přidání Triggers
    const triggersEl = xmlDoc.createElementNS(WORKFLOW_XML_NAMESPACE, CONST_TRIGGERS_EL);
    for (const trigger of activity.triggers) {
        await trigger.validate();
        addTriggerElement(xmlDoc, triggersEl, trigger);
    }

    // Přidání Positions
    const positionsEl = xmlDoc.createElementNS(WORKFLOW_XML_NAMESPACE, CONST_POSITION_EL);
    activity.positions.forEach(position => {
        addPositionElement(xmlDoc, positionsEl, position, sets);
    });

    activity.actions.length > 0 && activityEl.appendChild(actionsEl);
    activity.transitions.length > 0 && activityEl.appendChild(transitionsEl);
    activity.participants.length > 0 && activityEl.appendChild(participantsEl);
    activity.triggers.length > 0 && activityEl.appendChild(triggersEl);
    activityEl.appendChild(positionsEl);
    wfElement.appendChild(activityEl);
};

const addActionElement = (xmlDoc: Document, actionsEl: Element, action: Action) => {
    let actionEl: Element | null = null;

    switch (action.constructor) {
        case CallMethod: {
            actionEl = xmlDoc.createElementNS(WORKFLOW_XML_NAMESPACE, CONST_CALL_METHOD_EL);
            const callMethod = action as CallMethod;
            callMethod.condition && actionEl.setAttribute(CONST_ACTION_CONDITION_AT, callMethod.condition);
            actionEl.setAttribute(CONST_ACTION_COMMENT_AT, callMethod.comment);
            actionEl.setAttribute(CONST_CALL_METHOD_METHOD_NAME_AT, callMethod.methodName);
            actionEl.setAttribute(CONST_CALL_METHOD_STATIC_AT, callMethod.static ? "true" : "false");
            actionEl.setAttribute(CONST_CALL_METHOD_INSERT_ACTUAL_OBJECT_AT, callMethod.insertActualObject ? "true" : "false");
            actionEl.setAttribute(CONST_CALL_METHOD_INSERT_PARAM_FORM_OBJECT_AT, callMethod.insertParamFormObject ? "true" : "false");
            actionEl.setAttribute(CONST_CALL_METHOD_DEFAULT_PARAM_VALUE_AT, callMethod.defaultParamValue);
            break;
        }
        case CallScript: {
            actionEl = xmlDoc.createElementNS(WORKFLOW_XML_NAMESPACE, CONST_CALL_SCRIPT_EL);
            const callScript = action as CallScript;
            callScript.condition && actionEl.setAttribute(CONST_ACTION_CONDITION_AT, callScript.condition);
            actionEl.setAttribute(CONST_ACTION_COMMENT_AT, callScript.comment);
            actionEl.innerHTML = escapeXmlString(callScript.script);
            break;
        }
        case IncrementDateTime: { // TODO - projednat sloučení s IncrementNumber
            actionEl = xmlDoc.createElementNS(WORKFLOW_XML_NAMESPACE, CONST_INCREMENT_DATE_TIME_EL);
            const incrementDateTime = action as IncrementDateTime;
            incrementDateTime.condition && actionEl.setAttribute(CONST_ACTION_CONDITION_AT, incrementDateTime.condition);
            actionEl.setAttribute(CONST_ACTION_COMMENT_AT, incrementDateTime.comment);
            actionEl.setAttribute(CONST_INCREMENT_DATE_TIME_VALUE_AT, incrementDateTime.value.toString());
            actionEl.setAttribute(CONST_INCREMENT_DATE_TIME_PRECISION_AT, incrementDateTime.precision);
            actionEl.setAttribute(CONST_INCREMENT_DATE_TIME_ATTR_NAME_AT, incrementDateTime.attrName);
            break;
        }
        case IncrementNumber: {
            actionEl = xmlDoc.createElementNS(WORKFLOW_XML_NAMESPACE, CONST_INCREMENT_NUMBER_EL);
            const incrementNumber = action as IncrementNumber;
            incrementNumber.condition && actionEl.setAttribute(CONST_ACTION_CONDITION_AT, incrementNumber.condition);
            actionEl.setAttribute(CONST_ACTION_COMMENT_AT, incrementNumber.comment);
            actionEl.setAttribute(CONST_INCREMENT_NUMBER_ATTR_NAME_AT, incrementNumber.attrName);
            actionEl.setAttribute(CONST_INCREMENT_NUMBER_VALUE_AT, incrementNumber.value.toString());
            break;
        }
        case SendMail: {
            actionEl = xmlDoc.createElementNS(WORKFLOW_XML_NAMESPACE, CONST_SEND_MAIL_EL);
            const sendMail = action as SendMail;
            sendMail.condition && actionEl.setAttribute(CONST_ACTION_CONDITION_AT, sendMail.condition);
            actionEl.setAttribute(CONST_ACTION_COMMENT_AT, sendMail.comment);
            actionEl.setAttribute(CONST_SEND_MAIL_RECIPIENT_AT,
                sendMail.recipientType === SendMessageRecipientType.condition
                    ? `${sendMail.className};${sendMail.attrName};${sendMail.dataCondition}` : sendMail.recipient);
            actionEl.setAttribute(CONST_SEND_MAIL_SUBJECT_AT, sendMail.subject);
            actionEl.setAttribute(CONST_SEND_MAIL_TEXT_AT, sendMail.text);
            actionEl.setAttribute(CONST_SEND_MAIL_REPORT_TEMPLATE_AT, sendMail.reportTemplate);
            actionEl.setAttribute(CONST_SEND_MAIL_SUMMARY_MAIL_AT, sendMail.summaryMail ? "true" : "false");
            actionEl.setAttribute(CONST_SEND_MAIL_FORMAT_AT, sendMail.format);
            actionEl.setAttribute(CONST_SEND_MAIL_DOCUMENT_CLASS_NAME_AT, sendMail.documentClassName);
            actionEl.setAttribute(CONST_SEND_MAIL_DOCUMENT_ATTRIBUTE_AT, sendMail.documentAttribute);
            actionEl.setAttribute(CONST_SEND_MAIL_DOCUMENT_CONDITION_AT, sendMail.documentCondition);
            actionEl.setAttribute(CONST_SEND_MAIL_DOCUMENT_CONDITION_PARAMS_AT, sendMail.documentConditionParams);
            actionEl.setAttribute(CONST_SEND_MAIL_SEND_POSTPONE_AT, sendMail.sendPostpone ? "true" : "false");
            actionEl.setAttribute(CONST_SEND_MAIL_RECIPIENT_TYPE_AT, sendMail.recipientType);
            break;
        }
        case SendSMS: {
            actionEl = xmlDoc.createElementNS(WORKFLOW_XML_NAMESPACE, CONST_SEND_SMS_EL);
            const sendSms = action as SendSMS;
            sendSms.condition && actionEl.setAttribute(CONST_ACTION_CONDITION_AT, sendSms.condition);
            actionEl.setAttribute(CONST_ACTION_COMMENT_AT, sendSms.comment);
            actionEl.setAttribute(CONST_SEND_SMS_RECIPIENT_AT,
                sendSms.recipientType === SendSmsRecipientType.condition
                    ? `${sendSms.className};${sendSms.attrName};${sendSms.dataCondition}` : sendSms.recipient);
            actionEl.setAttribute(CONST_SEND_SMS_TEXT_AT, sendSms.text);
            actionEl.setAttribute(CONST_SEND_SMS_RECIPIENT_TYPE_AT, sendSms.recipientType);
            break;
        }
        case SendWFMessage: {
            actionEl = xmlDoc.createElementNS(WORKFLOW_XML_NAMESPACE, CONST_SEND_WF_MESSAGE_EL);
            const sendWfMessage = action as SendWFMessage;
            sendWfMessage.condition && actionEl.setAttribute(CONST_ACTION_CONDITION_AT, sendWfMessage.condition);
            actionEl.setAttribute(CONST_ACTION_COMMENT_AT, sendWfMessage.comment);
            actionEl.setAttribute(CONST_SEND_WF_MESSAGE_MESSAGE_NAME_AT, sendWfMessage.messageName);
            actionEl.setAttribute(CONST_SEND_WF_MESSAGE_TARGET_OBJECT_NAME_AT, sendWfMessage.targetObjectName);
            actionEl.setAttribute(CONST_SEND_WF_MESSAGE_OBJECTS_CONDITION_AT, sendWfMessage.objectsCondition);
            actionEl.setAttribute(CONST_SEND_WF_MESSAGE_OBJECTS_CONDITION_PARAMS_AT, sendWfMessage.objectsConditionParams);
            actionEl.setAttribute(CONST_SEND_WF_MESSAGE_AFTER_SAVE_AT, sendWfMessage.afterSave ? "true" : "false");
            break;
        }
        case SetAttribute: {
            actionEl = xmlDoc.createElementNS(WORKFLOW_XML_NAMESPACE, CONST_SET_ATTRIBUTE_EL);
            const setAttribute = action as SetAttribute;
            setAttribute.condition && actionEl.setAttribute(CONST_ACTION_CONDITION_AT, setAttribute.condition);
            actionEl.setAttribute(CONST_ACTION_COMMENT_AT, setAttribute.comment); // TODO - proč někde comment je a někde není? Chci zrušit, pokud bude empty string
            actionEl.setAttribute(CONST_SET_ATTRIBUTE_VALUE_TYPE, (SetAttributeValueType as any)[setAttribute.valueType]);
            actionEl.setAttribute(CONST_SET_ATTRIBUTE_ATTR_NAME_AT, setAttribute.attrName);

            if (setAttribute.value && (setAttribute.valueType === SetAttributeValueType.typedValue || setAttribute.valueType === SetAttributeValueType.untypedValue)) {
                const valueEl = xmlDoc.createElementNS(WORKFLOW_XML_NAMESPACE, CONST_SET_ATTRIBUTE_VALUE_EL);
                const escapedValue = escapeXmlString(setAttribute.value);
                valueEl.innerHTML = escapedValue;
                valueEl.setAttribute("xsi:type", "xsd:string");
                actionEl.appendChild(valueEl);
            }

            break;
        }
        case SetObjectAttribute: {
            actionEl = xmlDoc.createElementNS(WORKFLOW_XML_NAMESPACE, CONST_SET_OBJECT_ATTRIBUTE_EL);
            const setObjectAttribute = action as SetObjectAttribute;
            setObjectAttribute.condition && actionEl.setAttribute(CONST_ACTION_CONDITION_AT, setObjectAttribute.condition);
            actionEl.setAttribute(CONST_ACTION_COMMENT_AT, setObjectAttribute.comment);
            actionEl.setAttribute(CONST_SET_OBJECT_ATTRIBUTE_ATTR_NAME_AT, setObjectAttribute.attrName);
            actionEl.setAttribute(CONST_SET_OBJECT_ATTRIBUTE_MASTER_CLASS_NAME_AT, setObjectAttribute.masterClassName);
            actionEl.setAttribute(CONST_SET_OBJECT_ATTRIBUTE_MASTER_ATTR_NAME_AT, setObjectAttribute.masterAttrName);
            const valueEl = xmlDoc.createElementNS(WORKFLOW_XML_NAMESPACE, CONST_SET_OBJECT_ATTRIBUTE_VALUE_EL);
            valueEl.innerHTML = escapeXmlString(setObjectAttribute.value);
            actionEl.appendChild(valueEl);
            break;
        }
        case SetValue: {
            actionEl = xmlDoc.createElementNS(WORKFLOW_XML_NAMESPACE, CONST_SET_VALUE_EL);
            const setValue = action as SetValue;
            setValue.condition && actionEl.setAttribute(CONST_ACTION_CONDITION_AT, setValue.condition);
            actionEl.setAttribute(CONST_ACTION_COMMENT_AT, setValue.comment);
            actionEl.setAttribute(CONST_SET_VALUE_NAME_AT, setValue.name);

            if (setValue.value !== "") {
                const valueEl = xmlDoc.createElementNS(WORKFLOW_XML_NAMESPACE, CONST_SET_VALUE_VALUE_EL);
                const escapedValue = escapeXmlString(setValue.value);
                const xsiType = getCsharpTypeFromString(escapedValue);
                valueEl.innerHTML = escapedValue;
                valueEl.setAttribute("xsi:type", `xsd:${xsiType}`);
                actionEl.appendChild(valueEl);
            }

            break;
        }
        case OpenForm: {
            /* Jakmile bude refaktorována akce pro otevření formuláře, tak se může začít implementovat kód v komentáři
            actionEl = xmlDoc.createElementNS(workflowXmlNamespace, OpenForm);
            const setValue = action as OpenForm;
            setValue.condition && actionEl.setAttribute(CONST_ACTION_CONDITION_AT, setValue.condition);
            actionEl.setAttribute(CONST_ACTION_COMMENT_AT, setValue.comment);*/
            return;
        }
        default: {
            throw new Error(`Action of specified type '${action.constructor}' doesn't exist! Could not create XML of workflow!`);
        }
    }

    actionsEl.appendChild(actionEl);
};

const addTransitionElement = (xmlDoc: Document, transitionsEl: Element, transition: Transition, sets: Set[]) => {
    const transtionEl = xmlDoc.createElementNS(WORKFLOW_XML_NAMESPACE, CONST_TRANSITION_EL);

    transition.condition && transtionEl.setAttribute(CONST_TRANSITION_CONDITION_AT, transition.condition);
    transtionEl.setAttribute(CONST_TRANSITION_ID_AT, transition.id);
    transtionEl.setAttribute(CONST_TRANSITION_NAME_AT, transition.name);
    transtionEl.setAttribute(CONST_TRANSITION_TO_AT, transition.to);

    // Přidání akcí
    const actionsEl = xmlDoc.createElementNS(WORKFLOW_XML_NAMESPACE, CONST_ACTIONS_EL);
    transition.actions.forEach(action => {
        addActionElement(xmlDoc, actionsEl, action);
    });
    manageOpenFormAction(WORKFLOW_XML_NAMESPACE, xmlDoc, actionsEl, transition.actions); // Stará se o zpracování akcí OpenForm, snad se brzo refaktoruje, ať to odtud zmizí :(

    // Přidání pointů
    const drawEl = xmlDoc.createElementNS(WORKFLOW_XML_NAMESPACE, CONST_DRAW_EL);
    const setIndex = sets.findIndex(set => set.id === transition.setId);
    drawEl.setAttribute(CONST_DRAW_SET_AT, setIndex.toString());
    transition.points.forEach(point => {
        addPointElement(xmlDoc, drawEl, point);
    });

    transition.actions.length > 0 && transtionEl.appendChild(actionsEl);
    transtionEl.appendChild(drawEl);
    transitionsEl.appendChild(transtionEl);
};

const addParticipantElement = (xmlDoc: Document, participantsEl: Element, participant: Participant) => {
    let participantEl: Element | null = null;

    switch (participant.constructor) {
        case DefinitionParticipant: { // TODO - velmi podobné, jako funkce addDefinitionParticipantElement, vymyslet lépe!
            participantEl = xmlDoc.createElementNS(WORKFLOW_XML_NAMESPACE, CONST_DEFINITION_PARTICIPANT_EL);
            const definitionParticipant = participant as DefinitionParticipant;
            participantEl.setAttribute(CONST_DEFINITION_PARTICIPANT_NAME_AT, definitionParticipant.name);
            participantEl.setAttribute(CONST_DEFINITION_PARTICIPANT_CONDITION_AT, definitionParticipant.condition);
            participantEl.setAttribute(CONST_DEFINITION_PARTICIPANT_ROLE_NAME_AT, definitionParticipant.roleName);
            break;
        }
        case Owner: {
            participantEl = xmlDoc.createElementNS(WORKFLOW_XML_NAMESPACE, CONST_OWNER_EL);
            break;
        }
        case Role: {
            participantEl = xmlDoc.createElementNS(WORKFLOW_XML_NAMESPACE, CONST_ROLE_EL);
            const role = participant as Role;
            participantEl.setAttribute(CONST_ROLE_DB_ID_AT, role.dbID.toString());
            participantEl.setAttribute(CONST_ROLE_NAME_AT, role.name);
            break;
        }
        case System: {
            participantEl = xmlDoc.createElementNS(WORKFLOW_XML_NAMESPACE, CONST_SYSTEM_EL);
            break;
        }
        case User: {
            participantEl = xmlDoc.createElementNS(WORKFLOW_XML_NAMESPACE, CONST_USER_EL);
            const user = participant as Role;
            participantEl.setAttribute(CONST_USER_DB_ID_AT, user.dbID.toString());
            participantEl.setAttribute(CONST_USER_NAME_AT, user.name);
            break;
        }
        default: {
            throw new Error(`Participant of specified type '${participant.constructor}' doesn't exist! Could not create XML of workflow!`);
        }
    }

    participantsEl.appendChild(participantEl);
};

const addTriggerElement = (xmlDoc: Document, triggersEl: Element, trigger: Trigger) => {
    let triggerEl: Element | null = null;

    switch (trigger.constructor) {
        case AttributeDataChange: {
            triggerEl = xmlDoc.createElementNS(WORKFLOW_XML_NAMESPACE, CONST_ATTRIBUTE_DATA_CHANGE_EL);
            const attributeDataChange = trigger as AttributeDataChange;
            triggerEl.setAttribute(CONST_ATTRIBUTE_DATA_CHANGE_ATTR_NAME_AT, attributeDataChange.attrName),
            triggerEl.setAttribute(CONST_ATTRIBUTE_DATA_CHANGE_CONDITION_AT, attributeDataChange.condition);
            break;
        }
        case Menu: {
            triggerEl = xmlDoc.createElementNS(WORKFLOW_XML_NAMESPACE, CONST_MENU_EL);
            const menu = trigger as Menu;
            triggerEl.setAttribute(CONST_MENU_IDENTIFIER_AT, menu.identifier),
            menu.codename && triggerEl.setAttribute(CONST_MENU_CODE_NAME, menu.codename),
            menu.iconName && triggerEl.setAttribute(CONST_MENU_ICON_NAME, menu.iconName),
            menu.participantsSelecting && triggerEl.setAttribute(CONST_MENU_PARTICIPANTS_SELECTING_AT, "true"),
            !menu.multiActionEnable && triggerEl.setAttribute(CONST_MENU_MULTI_ACTION_ENABLE_AT, "false"),
            menu.validatePostReq && triggerEl.setAttribute(CONST_MENU_VALIDATE_POST_REQ_AT, "true"),
            menu.validateRecommended && triggerEl.setAttribute(CONST_MENU_VALIDATE_RECOMMENDED_AT, "true"),
            menu.chooseFromUsersDefault && triggerEl.setAttribute(CONST_MENU_CHOOSE_FROM_USERS_DEFAULT, "true");
            triggerEl.setAttribute(CONST_MENU_MASTER_NODE_AT, menu.masterNode),
            triggerEl.setAttribute(CONST_MENU_PARAM_FORM_NAME_AT, menu.paramFormName),
            triggerEl.setAttribute(CONST_MENU_LINK_ATTR_FOR_SEL_OBJ_AT, menu.linkAttrForSelObj),
            triggerEl.setAttribute(CONST_MENU_SET_VALUES_AT, menu.setValues);

            const captionsEl = xmlDoc.createElementNS(WORKFLOW_XML_NAMESPACE, CONST_MENU_CAPTIONS_EL);
            menu.captions.forEach(caption => {
                const textEl = xmlDoc.createElementNS(WORKFLOW_XML_NAMESPACE, CONST_MENU_TEXT_EL);
                textEl.setAttribute(CONST_MENU_LANG_AT, caption.lang);
                textEl.setAttribute(CONST_MENU_TEXT_AT, caption.text);
                captionsEl.append(textEl);
            });

            const confirmMessagesEl = xmlDoc.createElementNS(WORKFLOW_XML_NAMESPACE, CONST_MENU_CONFIRM_MESSAGES_EL);
            menu.confirmMessages.forEach(confirmMessage => {
                const textEl = xmlDoc.createElementNS(WORKFLOW_XML_NAMESPACE, CONST_MENU_TEXT_EL);
                textEl.setAttribute(CONST_MENU_LANG_AT, confirmMessage.lang);
                textEl.setAttribute(CONST_MENU_TEXT_AT, confirmMessage.text);
                confirmMessagesEl.append(textEl);
            });

            triggerEl.appendChild(captionsEl);
            triggerEl.appendChild(confirmMessagesEl);
            break;
        }
        case NewObject: {
            triggerEl = xmlDoc.createElementNS(WORKFLOW_XML_NAMESPACE, CONST_NEW_OBJECT_EL);
            break;
        }
        case WfMessage: {
            triggerEl = xmlDoc.createElementNS(WORKFLOW_XML_NAMESPACE, CONST_WFMESSAGE_EL);
            const wfMessage = trigger as WfMessage;
            triggerEl.setAttribute(CONST_WFMESSAGE_MESSAGE_NAME_AT, wfMessage.messageName);
            wfMessage.deactivating && triggerEl.setAttribute(CONST_WFMESSAGE_DEACTIVATING_AT, "true");
            break;
        }
        default: {
            throw new Error(`Trigger of specified type '${trigger.constructor}' doesn't exist! Could not create XML of workflow!`);
        }
    }

    triggersEl.appendChild(triggerEl);
};

const addPositionElement = (xmlDoc: Document, positionsEl: Element, position: Position, sets: Set[]) => {
    const positionEl = xmlDoc.createElementNS(WORKFLOW_XML_NAMESPACE, CONST_POSITION_EL);
    const setIndex = sets.findIndex(set => set.id === position.set.id);

    positionEl.setAttribute(CONST_POSITION_X_AT, position.x.toString());
    positionEl.setAttribute(CONST_POSITION_Y_AT, position.y.toString());
    positionEl.setAttribute(CONST_POSITION_WIDTH_AT, position.width.toString());
    positionEl.setAttribute(CONST_POSITION_HEIGHT_AT, position.height.toString());
    positionEl.setAttribute(CONST_POSITION_SET_AT, setIndex.toString());

    positionsEl.appendChild(positionEl);
};

const addPointElement = (xmlDoc: Document, drawEl: Element, point: Point) => {
    const pointEl = xmlDoc.createElementNS(WORKFLOW_XML_NAMESPACE, CONST_POINT_EL);

    pointEl.setAttribute(CONST_POINT_X_AT, point.x.toString());
    pointEl.setAttribute(CONST_POINT_Y_AT, point.y.toString());

    drawEl.appendChild(pointEl);
};

const addSetElement = (xmlDoc: Document, setDefinitionsEl: Element, set: Set) => {
    const setEl = xmlDoc.createElementNS(WORKFLOW_XML_NAMESPACE, CONST_SET_EL);

    setEl.setAttribute(CONST_SET_NAME_AT, set.name);
    setEl.setAttribute(CONST_SET_DESCRIPTION_AT, set.description);

    setDefinitionsEl.appendChild(setEl);
};

const addDefinitionParticipantElement = (xmlDoc: Document, definitionParticipantsEl: Element, definitionParticipant: DefinitionParticipant) => {
    const definitionParticpantEl = xmlDoc.createElementNS(WORKFLOW_XML_NAMESPACE, CONST_DEFINITION_PARTICIPANT_EL);

    definitionParticpantEl.setAttribute(CONST_DEFINITION_PARTICIPANT_NAME_AT, definitionParticipant.name);
    definitionParticpantEl.setAttribute(CONST_DEFINITION_PARTICIPANT_CONDITION_AT, definitionParticipant.condition);
    definitionParticpantEl.setAttribute(CONST_DEFINITION_PARTICIPANT_ROLE_NAME_AT, definitionParticipant.roleName);

    definitionParticipantsEl.appendChild(definitionParticpantEl);
};
